import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { LoaderComponent } from '../../loader/loader.component';
import { FormFieldAbstractComponent } from '../field-abstract/form-field.abstract.component';
import { FormFieldModel } from '../field-abstract/form-field.model';
@Component({
    imports: [CommonModule, TranslationModule, LoaderComponent, FormsModule],
    selector: 'form-field',
    templateUrl: 'form-field.html',
    styleUrls: ['../field-abstract/field.scss', 'form-field.scss'],
    providers: [FormFieldModel],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormFieldComponent extends FormFieldAbstractComponent {}
